export default {
    path : "land-item-important",
    name : "land-item-important",
    meta : {
        title : "重点接洽项目"
    },
    component: () => import('@/pages/land/important/Index'),
    redirect: {
        name : "land-item-important-whole"
    },
    children: [
        {
            path: 'all',
            name: 'land-item-important-whole',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'land-item-important-recent',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'land-item-important-atme',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'land-item-important-meat',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'land-item-important-reply',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'land-item-important-search',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/land/importantitem/index.js